import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useNavigate } from "react-router-dom";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

const Unauthorized = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // Navigates to the previous page
  };

  const handleGoHome = () => {
    navigate("/"); // Navigates to the home page
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                pt={6}
                pb={6}
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                textAlign="center"
              >
                <MDTypography variant="h1" fontWeight="bold" color="error" gutterBottom>
                  403
                </MDTypography>
                <MDTypography variant="h4" fontWeight="medium" gutterBottom>
                  {/* Unauthorized Access */}
                  {t("lang.unauthorized")}
                </MDTypography>
                <MDTypography variant="body1" mb={4}>
                  {/* {`Sorry, you don't have permission to view this page.`} */}
                  {t("lang.unauthorized_text")}
                </MDTypography>
                <MDBox display="flex" gap={2} justifyContent="center">
                  <MDButton variant="gradient" color="info" onClick={handleGoBack}>
                    {/* Go Back */}
                    {t("lang.actions.go_back")}
                  </MDButton>
                  <MDButton variant="outlined" color="dark" onClick={handleGoHome}>
                    {/* Go to Home */}
                    {t("lang.actions.go_home")}
                  </MDButton>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
};

export default Unauthorized;
